import _default from './Flag';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Flag/index.js
// module id = 701
// module chunks = 0